import React from "react"
import { Spinner } from "react-bootstrap"

export const CellSpinner = () => {
  return (
    <div className="table-spinner d-inline-block">
      <Spinner animation="border" variant="primary" className="visible h-100 w-100" />
    </div>
  )
}